import React, { useEffect } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";

/**
 * React-controlled modal. Replaces the template's Bootstrap modals, which had
 * to be closed by querying the DOM for a dismiss button and clicking it.
 *
 * size: "sm" | "md" | "lg"
 */
const Modal = ({ open, title, size = "md", onClose, children, footer }) => {
  useEffect(() => {
    if (!open) return;

    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };

    // The page behind must not scroll while a modal owns the screen.
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", onKey);

    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", onKey);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="ms-modal-backdrop"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose?.();
      }}
    >
      <div className={`ms-modal ms-modal--${size}`} role="dialog" aria-modal="true">
        {title && (
          <div className="ms-modal-head">
            <h2>{title}</h2>
            <button type="button" className="ms-modal-x" onClick={onClose} aria-label="Ёпиш">
              <Icon icon="tabler:x" />
            </button>
          </div>
        )}

        <div className="ms-modal-body">{children}</div>

        {footer && <div className="ms-modal-foot">{footer}</div>}
      </div>
    </div>
  );
};

export default Modal;
